<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Aplicaciones Contables</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <vs-card>
            <template slot="header">
              <h1 class="md-title">Transacciones</h1>
              <vs-input
                  class="w-1/4"
                  placeholder="Buscar..."
                  icon="search"
                  v-model="search"
                  @keyup.enter="fetchTransactions"></vs-input>
            </template>

            <vs-table
                stripe
                :data="searched"
                :no-data-text="`No se encontró transacción que contenga '${search}' en el concepto o en el tipo de TRX. Intente una búsqueda diferente.`"
                >
              <template slot-scope="{data}">
                <vs-tr
                    class="cursor-pointer"
                    v-if="item"
                    v-for="item in data"
                    :key="item.id"
                >
                  <vs-td>
                    <div @click="selectedHandler(item)" class="underline">
                    {{ item.trx_type }}
                    </div>
                  </vs-td>
                  <vs-td>{{ item.concept }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </div>

      <!-- PAGINADOR -->
      <div class="flex items-center justify-center con-pagination-table vs-table--pagination">
        <vs-pagination
            v-model="current_page"
            :total="last_page"
            @change="searchHandler"
          />
      </div>

      <vs-popup :active.sync="showDialog" :title="selectedText">
          <vs-card>

              <md-table>
                <md-table-row>
                  <md-table-head>Tipo de TRX</md-table-head>
                  <md-table-head>Cuenta</md-table-head>
                  <md-table-head>Nombre Cta</md-table-head>
                  <md-table-head style="text-align: center">Cargo M.E.</md-table-head>
                  <md-table-head style="text-align: center">Abono M.E.</md-table-head>
                  <md-table-head style="text-align: center">Cargo</md-table-head>
                  <md-table-head style="text-align: center">Abono</md-table-head>
                  <md-table-head>Diario</md-table-head>
                  <md-table-head />
                </md-table-row>

                <md-table-row v-for="(aa,index) in applications" :key="aa.id">
                  <md-table-cell>{{aa.trx_type}}</md-table-cell>

                  <md-table-cell v-if="edit === false">{{aa.account}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field md-inline>
                      <label>Cuenta</label>
                      <md-input v-model="aa.account" maxlength="16"></md-input>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell v-if="edit === false">{{aa.account_name}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field md-inline>
                      <label>Nombre Cta.</label>
                      <md-input v-model="aa.account_name" />
                    </md-field>
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="aa.foreign_currency_debit" :disabled="edit === false">
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="aa.foreign_currency_credit" :disabled="edit === false"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="aa.debit" :disabled="edit === false"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="aa.credit" :disabled="edit === false"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell v-if="edit === false">{{aa.day_book}}</md-table-cell>
                  <md-table-cell v-else>
                    <md-field md-inline>
                      <label>Diario</label>
                      <md-input v-model="aa.day_book" />
                    </md-field>
                  </md-table-cell>

                  <md-table-cell v-if="edit === false">
                    <md-button class="md-icon-button md-raised md-accent" v-on:click="borrar(aa.id, index)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>


              <div class="mt-6" v-if="edit === false">
                <vs-button icon="edit" v-on:click="edit=true">
                </vs-button>
              </div>
              <div class="mt-6" v-else>
                <vs-button icon="save" v-on:click="guardar()">
                </vs-button>
                <vs-button icon="add" color="secondary" class="text-dark" v-on:click="agregar()">
                </vs-button>
              </div>
          </vs-card>
      </vs-popup>
    </div>
  </div>

</template>

<script lang="js">
  import axios from 'axios';

  export default  {
    name: 'applications',
    props: [],
    async mounted() {
      await this.fetchTransactions();
    },
    data() {
      return {
        selected: '',
        selectedText: '',
        search: null,
        searched: [],
        transactions: [],
        applications: [],
        edit:false,
        max_id: 0,
        showDialog: false,
        current_page: 1,
        per_page: 20,
        total: 0,
        last_page: 1,
      }
    },
    methods: {
      searchHandler() {
        this.current_page = 1;
        this.fetchTransactions();
      },
      async fetchTransactions() {
        this.$vs.loading();
        try {
          const {data} = await axios.get('/api/accounting/transactions', {
            params: {
              query: this.search,
              per_page: this.per_page,
              page: this.current_page,
            }
          });

          const rows = data.data ?? [];
          this.transactions = rows;
          this.searched = rows;
          this.total = data.total ?? 0;
          this.last_page = data.last_page ?? 1;
          this.current_page = data.current_page ?? this.current_page;
        } catch (error) {
          console.error(error);
        } finally {
          this.$vs.loading.close();
        }
    },
      selectedHandler(item){
        this.selected = item;
        this.onSelect(item);
      },
      guardar(){
        Vue.toasted.show('Guardando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/applications/save', {
          'applications' : this.applications,
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('Guardado con éxito!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 5000 });
          this.edit = false;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 5000})
        });
      },
      agregar(){
        this.max_id++;
        this.applications.push({
                'id': this.max_id,
                'trx_type': this.selected.trx_type,
                'account': '',
                'account_name': '',
                'foreign_currency_debit': 0,
                'foreign_currency_credit': 0,
                'debit': 0,
                'credit': 0 ,
                'day_book': ''
        });
      },
      borrar(id, index){
        Vue.toasted.show('Borrando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/applications/delete', {
          'id' : id
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('Borrado exitoso!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 5000 });
          this.applications.splice(index, 1);
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 5000})
        });
      },
      onSelect (item) {
        this.selected = item;
        this.selectedText = item.trx_type+' - '+item.concept;
        this.showDialog = true;
      },
      cerrarDialog(){
        this.showDialog = false;
        this.selected = null;
        this.selectedText = '';
        this.applications = [];
        this.edit = false;
      }
    },
    watch: {
      selected:function(){
        if(this.selected !== null){
          axios.post( '/api/accounting/applications', {
            'trx_type' : this.selected.trx_type
          }).then(response => {
            this.applications = response.data.data;
            this.max_id = response.data.max_id;
          })
        }
      }
    }
}
</script>
<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
